import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Form, Formik } from 'formik';

import ResponsiveModal from '../../../ResponsiveModal';
import Button from '../../../Button';
import Textarea from '../../../Form/components/Textarea';
import { IReportPopupProps, ICategorySelector } from './types';
import Selector from '../Selector';

export const ReportPopup = ({
  isOpenReportModal,
  onClose,
  submitCustomReport,
}: LT.WithChildren<IReportPopupProps>): JSX.Element => {
  const [reportText, setReportText] = useState('');
  const [categoryValue, setCategoryValue] = useState<
    string | ICategorySelector
  >('');
  const [isSentReport, setIsSentReport] = useState(false);

  const initialValues = {
    reportInput: '',
    categorySelector: {},
  };

  const options = [
    { id: '1', label: 'Звонки', value: 'dialer' },
    { id: '2', label: 'Сообщения/цепочки', value: 'chains' },
    { id: '3', label: 'Тикеты', value: 'tickets' },
  ];

  const handleChangeReportInput = (newValue: string) => {
    setReportText(newValue);
  };

  const handleChangeReportSelector = (newCategory: ICategorySelector) => {
    setCategoryValue(newCategory);
  };

  const onSubmit = useCallback(
    data => {
      submitCustomReport(data);

      // у Сентри нельзя отследить, был ли выполнен метод captureException/captureMessage, поэтому просто эмулируем запрос лоадером
      setIsSentReport(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    },
    [submitCustomReport, onClose]
  );

  return (
    <ResponsiveModal
      open={isOpenReportModal}
      onClose={onClose}
      closeOnOverlayClick
      styles={{ modal: { maxWidth: 500, width: '100%' } }}
      center
    >
      <div>
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {({ setFieldValue }) => (
            <Form>
              {isSentReport && (
                <StyledDisableWrapper>
                  <StyledLoader />
                </StyledDisableWrapper>
              )}
              <StyledReportTitle>Создание репорта об ошибке</StyledReportTitle>
              <StyledInput
                onChange={handleChangeReportInput}
                value={reportText}
                name="reportInput"
                placeholder="Кратко опишите возникшую проблему"
                nativeInputProps={{
                  style: {
                    fontSize: '13px',
                    padding: '8px 10px',
                    fontWeight: 'normal',
                  },
                }}
              />
              <StyledSelector
                onChange={(val: ICategorySelector) => {
                  handleChangeReportSelector(val);
                  setFieldValue('categorySelector', val);
                }}
                options={options}
                placeholder="Выберите категорию проблемы"
                value={categoryValue}
                name="categorySelector"
              />
              <StyledButton type="submit">Отправить</StyledButton>
            </Form>
          )}
        </Formik>
      </div>
    </ResponsiveModal>
  );
};

const StyledDisableWrapper = styled.div`
  background-color: rgba(154, 154, 154, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9;
`;

const StyledLoader = styled.div`
  &:after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 4px solid #2ac4fb;
    border-color: #2a7cfb transparent #2a7cfb transparent;
    animation: lds-dual-ring 1.2s linear infinite;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const StyledButton = styled(Button)`
  margin: 10px auto 0 auto;
  display: block;
`;

const StyledSelector = styled(Selector)`
  width: 100%;
  border: 1px solid #e6e9ee;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px;
  margin-top: 10px;

  .selector__menu {
    right: 0;
  }

  .selector__placeholder {
    font-size: 13px;
    color: #c8cbd0;
  }
`;

const StyledReportTitle = styled.h2`
  font-size: 18px;
  margin-bottom: 10px;
`;

const StyledInput = styled(Textarea)`
  width: 100%;
  font-size: 14px;
  border-radius: 4px;
`;
